<template>
  <div class="images">
    <div class="title-box">
      <div class="title">{{ list.name }}</div>
      <div><el-link :underline="false" class="more" v-if="list.url" :href="'#'+'/article'+list.url">更多 +</el-link></div>
    </div>
    <div class="body-box">
      <swiper
          :slides-per-view="7"
          :space-between="1"
          @swiper="onSwiper"
          @slideChange="onSlideChange">
        <template v-for="item in list.contents" :key="item.id">
          <swiper-slide><a :href="'#'+'/article'+list.url+'/'+item.id"><img :src="item.image" class="item"></a><div class="name" :title="item.subject">{{ item.subject }}</div></swiper-slide>
        </template>

      </swiper>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js'
import 'swiper/swiper.min.css'
//import image from "../assets/images/teacher.png"
export default ({
  name: "BaseSwiper",
  components: { Swiper, SwiperSlide },
  props: {
    list: {},
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      //console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  }
})
</script>

<style scoped>
.item {
  width: 90px;
  height: 110px;
}
.name{
  width: 90px;
  height: 20px;
  text-align: center;
  font-size: 14px;
  overflow: hidden;
}
/deep/ .el-carousel__item--card {
  width: 100px;
  height: 130px;
  margin: 0;
}
/deep/ .el-carousel__item is-active el-carousel__item--card is-in-stage{
  transpose: none!important;
}
.body-box {
  width: 775px;
  height: 130px;
  border: 1px solid #E3E3E3;
  padding: 10px;
}
.body-box .el-image {
  width: 100%;
  height: 130px;
}
.images {
  width: 797px;
  height: 200px;
  float: left;
}
.title-box {
  width: 797px;
  height: 36px;
  background: #F3F3F3;
  border-bottom: 2px solid #E3E3E3;
  margin-bottom: 10px;
}
.title {
  width: 100px;
  height: 34px;
  text-align: center;
  border-bottom:4px solid #BF2E11;
  float: left;
  color: #BF2E11;
  line-height: 40px;
  font-size: 18px;
  font-weight: bold;
}
.more {
  width: 60px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  float: right;
  font-size: 14px;
}
</style>